import { Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Calendar } from 'lucide-react';
import { api } from '@/lib/api';
import { fmtDate } from '@/lib/format';

export function EarningsStrip() {
  const q = useQuery({
    queryKey: ['earnings-upcoming'],
    queryFn: api.upcomingEarnings,
    staleTime: 15 * 60_000,
  });

  if (!q.data || q.data.items.length === 0) return null;
  const next = q.data.items.slice(0, 6);

  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-950 px-4 py-2 flex items-center gap-3 flex-wrap">
      <div className="flex items-center gap-2 shrink-0">
        <Calendar className="size-3.5 text-indigo-300" />
        <span className="text-[11px] uppercase tracking-wider text-zinc-400">Earnings</span>
      </div>
      <div className="flex items-center gap-2 flex-wrap flex-1">
        {next.map((e) => {
          const days = Math.max(
            0,
            Math.ceil((new Date(e.date).getTime() - Date.now()) / 86_400_000),
          );
          return (
            <Link
              to="/positions/$ticker"
              params={{ ticker: e.ticker }}
              key={e.ticker + e.date}
              className="inline-flex items-center gap-1.5 text-[11px] px-2 py-1 rounded-md border border-zinc-800 hover:border-zinc-700 text-zinc-300 hover:text-zinc-100 transition-colors"
            >
              <span className="font-mono text-zinc-200">{e.symbol}</span>
              <span className="text-zinc-400">·</span>
              <span className="text-zinc-400">{fmtDate(e.date).slice(0, 6)}</span>
              <span className="text-zinc-400">({days}d)</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
